import { SectionTabsLayout, type SectionTabItem } from "./section-tabs-layout";

const CONTENT_TABS: SectionTabItem[] = [
  {
    label: "Content",
    to: "/content",
    match: (pathname) => pathname === "/content",
  },
  {
    label: "Pages",
    to: "/pages",
    // /pages is the list; /pages/:pageSlug is one page's editor. Both belong to
    // this tab. The link used to point at /pages/homepage, a slug that never
    // existed - the catalogue is the PAGE_SURFACE_PLATFORM_* set (terms,
    // privacy, cookies, credo, careers, contact, press) and has no homepage:
    // the landing page is an editorial surface authored in Studio (ADR-025).
    match: (pathname) => pathname.startsWith("/pages"),
  },
  {
    label: "Trusted sites",
    to: "/trusted-sites",
    match: (pathname) => pathname === "/trusted-sites",
  },
  {
    // Placed here rather than under Users & Access: the panel's primary unit
    // is a writer's recent ARTICLES (judge verdicts, moderation state, the
    // live-article link), the same content-centric data the Content and
    // Trusted sites tabs show, and it drills into the same /content/:id
    // detail page. Users & Access is account/role administration (ban,
    // grant admin, provision an advertiser); the writer's identity is a
    // secondary fact here, not the subject.
    label: "New writers",
    to: "/new-writers",
    match: (pathname) => pathname === "/new-writers",
  },
];

export function ContentLayout() {
  return <SectionTabsLayout id="content" items={CONTENT_TABS} />;
}
